module.exports = __webpack_public_path__ + "img/thumbnail.b2c3348f.png";